import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SignInPageService {

    private API_URL= environment.API_URL;

    constructor(
        private http : HttpClient
    ) {}

    /*
    getUser(email: string) {
        let url = `${this.API_URL}/users?filters[email][$eq]=${email}`;
        return this.http.get(url, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}});
    }
    */
}